import React, { useContext } from "react";
import ConfiguratorContext from "./ConfiguratorContext";
import ConfiguratorSurveyOutputRender from "./ConfiguratorSurveyOutputRender";
import ServiceConfiguratorQuestionSelectOption from "./ServiceConfiguratorQuestionSelectOption";
import evaluateQuestionOutputValue from "@utils/evaluateQuestionOutputValue";

const ConfiguratorSurveyOutputQuestion = ({ output, realtime, responses, role }) => {

  const context = useContext(ConfiguratorContext);
  const value = evaluateQuestionOutputValue(
    output,
    {...context, responses: responses || context.responses}
  );

  const questionType = context.configuration
    .find((c) => c.id === output.output_input_id)
    .input_type;

  let option;

  switch (questionType) {
    case "select":
    case "multi_select":
      option = value;
      break;
    case "k_color_input":
      const field = output?.metadata_?.field
      switch (field) {
        case 'kColorProduct':
          option = {title: value?.des_prod_comm}
          break;
        case 'color':
          option = {title: value, isColor: true};
          break;
        case 'productPackage':
        default:
          option = {title: value}
          break;
      }
      break;
    default:
      option = {title: value}
      break;
  }

  return (
    <ConfiguratorSurveyOutputRender realtime={realtime} role={role} {...output}>
      <div className="text-right flex flex-col justify-center items-end">
        <ServiceConfiguratorQuestionSelectOption
          option={option}
          realtime={realtime}
          role={role}
          output
        />
      </div>
    </ConfiguratorSurveyOutputRender>
  );
};

export default ConfiguratorSurveyOutputQuestion;
